import { simplify } from '../../../shared/functions/meta.functions';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

export function submit(form: NgForm, searchMode: string, request, router: Router, route: ActivatedRoute) {
  if (form.invalid) {
    return;
  }
  markFormAsTouched(form);
  router.navigate(['./list', searchMode], {
    relativeTo: route,
    queryParams: { request: JSON.stringify(simplify(request)) }
  });
}

export function markFormAsTouched(form: NgForm) {
  for (const control of Object.values(form.controls)) {
    control.markAsTouched();
  }
}
